import {
  sendFeedbackEmail,
  FeedbackResponse,
  FeedbackData,
} from "@/api/feedback";
import { useMutation } from "@tanstack/react-query";

export const useSendFeedback = () => {
  return useMutation<FeedbackResponse, Error, FeedbackData>({
    mutationFn: sendFeedbackEmail,
  });
};
